import { useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const useAddressNavigation = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);

  const navigateWithParams: (pathname: string, envelope?: string | null) => void = useCallback(
    (pathname, envelope) => {
      if (envelope) {
        searchParams.set('envelope', envelope);
      }

      navigate({ pathname, search: searchParams.toString() });
    },
    [navigate, searchParams],
  );

  return { navigateWithParams };
};
